<template>
    <layouts-header></layouts-header>
    <layouts-sidebar></layouts-sidebar>
    <div class="page-wrapper">
      <div class="content">
        <div class="row">
          <div class="col-md-12">
            <!-- Page Header -->
            <page-header :title="title" />
            <!-- /Page Header -->
    
            <!-- Settings Menu -->
            <settings-tabs></settings-tabs>
            <!-- /Settings Menu -->
    
            <div class="row">
              <!-- <website-sidebar></website-sidebar> -->
    
              <div class="col-xl-12 col-lg-12">
                <!-- Company Settings -->
                <div class="card">
                  <div class="card-body settings-form">
                    <!-- Search -->
                    <div class="search-section">
                      <div class="row">
                        <div class="col-md-5 col-sm-4">
                          <div class="form-wrap icon-form">
                            <span class="form-icon">
                              <i class="ti ti-search"></i>
                            </span>
                            <input type="text" class="form-control" placeholder="Search Supplier name" v-model="searchUserQuery" @input="searchUsers" />
                          </div>
                        </div>
                        <div class="col-md-7 col-sm-8">
                        </div>
                      </div>
                    </div>
                    <!-- /Search -->
                    <div class="row mb-4 align-items-center">
                      <div class="col-md-5 col-sm-4">
                        <h4>Suppliers</h4>
                      </div>
                      <div class="col-md-7 col-sm-8">
                        <div class="export-list text-sm-end">
                          <a
                            class="me-3 export-link"
                            :class="{ 'disabled-link': !hasData }"
                            @click.prevent="hasData && exportToCSV()"
                          >
                            <i class="ti ti-filter-share"></i> Export CSV
                          </a>
                          <router-link class="btn btn-primary" to="/supplier/create-supplier">
                            Add Supplier</router-link>
                        </div>
                      </div>
                    </div>
                    <div class="table-responsive custom-table">
                      <supplier-table :search-user-query="searchUserQuery" ref="supplierTable"></supplier-table>
                    </div>
                    <div class="row align-items-center">
                      <div class="col-md-6">
                        <div class="datatable-length"></div>
                      </div>
                      <div class="col-md-6">
                        <div class="datatable-paginate"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- /Company Settings -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </template>
    
    <script>
    import { ref, computed } from "vue";
    import apiClient from "@/axios";
    import { message } from "ant-design-vue";

    export default {
      data() {
        return {
          title: "Settings",
        };
      },
      setup() {
        const searchUserQuery = ref("");
        const supplierTable = ref(null);

        const hasData = computed(() => {
          return (supplierTable.value?.dataCount?.length || 0) > 0;
        });

        const searchUsers = () => {
          supplierTable.value?.fetchSupplier();
        };

        const exportToCSV = async () => {
          try {
            const response = await apiClient.get("/suppliers/export-csv", {
              params: {
                search: searchUserQuery.value || undefined,
              },
            });
            if (response.data && response.data.data?.url) {
              const link = document.createElement("a");
              link.href = response.data.data.url;
              link.download = "";
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
            } else {
              message.error("Export failed or no URL found.");
            }
          } catch (error) {
            message.error(
              error?.response?.data?.message || "Unable to export suppliers."
            );
          }
        };

        return {
          searchUserQuery,
          supplierTable,
          hasData,
          searchUsers,
          exportToCSV,
        };
      },
    };
    </script>

<style>
a.export-link {
  cursor: pointer;
  text-decoration: none;
  transition: opacity 0.3s ease;
}

a.export-link.disabled-link {
  pointer-events: none;
  opacity: 0.5;
  color: #999;
  cursor: not-allowed;
}
</style>
